import * as React from 'react';
import type { SVGProps } from 'react';
const SvgUnmute = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="#A5A5AA"
      strokeLinecap="round"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M12.014 7v2.999M12.032 3a5.997 5.997 0 0 0-5.999 5.999v1.891c0 .613-.252 1.532-.567 2.054l-1.144 1.91c-.703 1.18-.216 2.495 1.08 2.927a21.023 21.023 0 0 0 13.269 0 2 2 0 0 0 1.08-2.927l-1.143-1.91c-.316-.522-.568-1.45-.568-2.054V9c-.009-3.298-2.71-6-6.008-6Z"
    />
    <path
      stroke="#A5A5AA"
      strokeMiterlimit={10}
      strokeWidth={1.5}
      d="M15.014 18.15c0 1.649-1.351 3-3 3-.82 0-1.576-.342-2.117-.883a3.005 3.005 0 0 1-.882-2.116"
    />
  </svg>
);
export default SvgUnmute;
